import React from 'react';

import { useDeleteTag } from 'scenes/Gallery/ConversionPages/ConversionPages/data';

import Actions from './Actions';

const TagActions = ({ data, onEdit }) => {
  const [deleteTag] = useDeleteTag();

  const handleDelete = () =>
    deleteTag({
      id: data.id,
      name: data.name,
    });

  const handleEdit = () => onEdit?.(data);

  return <Actions onEdit={handleEdit} onDelete={handleDelete} />;
};

export default TagActions;
